import { publicEnvSchema } from './env-schema'

const parsed = publicEnvSchema.parse(import.meta.env)

export const env = {
  apiHost: parsed.NEXT_PUBLIC_API_HOST,
  auth0Domain: parsed.NEXT_PUBLIC_AUTH0_DOMAIN,
  auth0ClientId: parsed.NEXT_PUBLIC_AUTH0_SPA_APP_CLIENT_ID,
  bugsnagApiKey: parsed.NEXT_PUBLIC_BUGSNAG_API_KEY,
  managerClientUrl: parsed.NEXT_PUBLIC_MANAGER_CLIENT_URL,
  posthogApiKey: parsed.NEXT_PUBLIC_POSTHOG_API_KEY,
  posthogApiUrl: parsed.NEXT_PUBLIC_POSTHOG_API_URL,
  mode: import.meta.env.MODE,
}
